$('.l-header-main__bottom-inner').click(function() {
  $(this).toggleClass('is-current');
  $('body').toggleClass('header-open-contents');
});